import * as yup from 'yup'

export const adminDiscountSchema = yup
  .object({
    code: yup.string().required(),
    discount: yup
      .number()
      .typeError('validation.requiredField')
      .required('validation.requiredField')
      .min(0)
      .max(100),
    partnerNameId: yup.string().required(),
    articleNo: yup.string().required(),
  })
  .required()
